import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NativeIntegrationService } from 'src/core/services/native-integration.service';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  didCheckForUpdate$ = new BehaviorSubject<boolean>(false);

  constructor(private nativeIntegrationService: NativeIntegrationService) {}

  async checkForUpdate() {
    try {
      const connectionResponse =
        await this.nativeIntegrationService.network.getInternetConnection$();
      console.log('[APP UPDATE]: Connection response', connectionResponse);
      // check if device is online
      if (
        connectionResponse.data === 'mobile' ||
        connectionResponse.data === 'lan'
      ) {
        const res =
          await this.nativeIntegrationService.content.getLatestInfo$();
        console.log('[APP UPDATE]: Has Update check', res);
        console.log(Object.values(res)[1].hasStaticDownloadUpdate);
        if (Object.values(res)[1].hasStaticDownloadUpdate) {
          this.nativeIntegrationService.content
            .updateZipContent$()
            .then((res) => {
              console.log('[APP UPDATE]: Zip response', res);
            })
            .finally(() => {
              this.didCheckForUpdate$.next(true);
            });
        }
      } else {
        this.didCheckForUpdate$.next(true);
      }
    } catch (error) {
      console.log('[APP UPDATE]: Error', error);
      this.didCheckForUpdate$.next(true);
    } finally {
      console.log('[APP UPDATE]: Finally');
      this.didCheckForUpdate$.next(true);
    }
  }
}
